var t = { icon: { tag: "svg", attrs: { viewBox: "0 0 16 16", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M8 13c.15 0 .3-.08.37-.2l4.55-6.91c.2-.3-.01-.7-.37-.7H10V.44C10 .2 9.7 0 9.33 0H6.67C6.3 0 6 .2 6 .45v4.73H3.45c-.36 0-.57.4-.37.7l4.55 6.92c.08.12.22.2.37.2zm4 3a1 1 0 000-2H4a1 1 0 000 2h8z", "fill-rule": "nonzero" } }] }, name: "to-bottom", theme: "filled" };
export {
  t as default
};
